import { parseToDate } from './dates';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

function startOfDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Whole days from today until expiry (negative = already expired). null = no expiry date. */
export function daysUntilExpiry(expiryDate, today = new Date()) {
  const d = parseToDate(expiryDate);
  if (!d) return null;
  return Math.round((startOfDay(d) - startOfDay(today)) / MS_PER_DAY);
}

/**
 * status: 'none' | 'expired' | 'today' | 'soon' (within warnDays) | 'ok'
 */
export function expiryStatus(expiryDate, warnDays = 30, today = new Date()) {
  const days = daysUntilExpiry(expiryDate, today);
  if (days === null) return { status: 'none', days: null };
  if (days < 0) return { status: 'expired', days };
  if (days === 0) return { status: 'today', days };
  if (days <= warnDays) return { status: 'soon', days };
  return { status: 'ok', days };
}

export function expiryLabel(days) {
  if (days === null || days === undefined) return '';
  if (days < 0) {
    const n = Math.abs(days);
    return `Expired ${n} day${n === 1 ? '' : 's'} ago`;
  }
  if (days === 0) return 'Expires today';
  return `${days} day${days === 1 ? '' : 's'} left`;
}
